// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/rtl.scss
// module id = 12
// module chunks = 0